import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-loader',
    templateUrl: './loader.component.html',
    styleUrls: ['./loader.component.scss'],
    standalone: true,
    imports: [CommonModule, TranslateModule],
})
export class LoaderComponent {
    @Input() overlay: boolean = false;
    @Input() globalLoader: boolean = false;
}
